import React from "react";

import styles from "./NoData.module.scss";

type Props = {
  text: string;
};

const NoData: React.FC<Props> = ({ text }) => {
  return (
    <>
      <div className={styles["nodata"]}>
        <i className={styles["decorator-slanted"]}></i>
        <span>No Data</span>
        <i className={styles["decorator-slanted"]}></i>
      </div>
      <div className={styles["nodata__message"]}>{text}</div>
    </>
  );
};

export default NoData;
